module.exports = __webpack_public_path__ + "checkmark-icon.69046591e954b3a16349410cf69e0cc6.svg";